import { Button } from "../ui/button";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <>
      <section className="relative overflow-hidden py-20 md:py-32 bg-background">
        <div className="container px-4 md:px-6">
          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="space-y-8"
            >
              <div className="space-y-4">
                <h1 className="text-4xl font-bold sm:text-5xl md:text-6xl">
                  The Job Interview Prep That Works
                </h1>
                <p className="max-w-[600px] text-gray-500 md:text-xl">
                After 15,000 hiring manager interviews and 5,000 coaching sessions, we developed InterviewAdvantage - our AI to help <i>you</i> become the #1 MUST hire candidate.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/signup">
                  <Button variant="default" size="lg" className="text-base">
                    Get Started
                  </Button>
                </Link>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-xl overflow-hidden">
                <img
                  src="/images/hero-home.webp"
                  alt="Interview Advantage"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>


    </>
  );
}
